module.exports = __webpack_public_path__ + "static/media/amu_logo.40167476.png";